(function () {
  const buildBreakpoints = (itemsToShow) => {
    const breakpoints = {};
    if (itemsToShow >= 2) {
      breakpoints[576] = { slidesPerView: Math.min(itemsToShow, 2) };
    }
    if (itemsToShow >= 3) {
      breakpoints[990] = { slidesPerView: Math.min(itemsToShow, 3) };
    }
    if (itemsToShow > 4) {
      breakpoints[1160] = { slidesPerView: 2 };
    }
    return breakpoints;
  };

  const initSlider = (section) => {
    const sliderEl = section.querySelector(".js-highlights-slider");

    if (!sliderEl) return;

    const nextBtn = section.querySelector(
      ".highlights__navigation-button-next"
    );
    const prevBtn = section.querySelector(
      ".highlights__navigation-button-prev"
    );
    const itemsToShow = Number(sliderEl.dataset.itemsToShow || 3);

    new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: buildBreakpoints(itemsToShow),
    });

    section.classList.add("has-active-slider");
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".js-highlights-slider");
    const slides = section.querySelectorAll(".js-highlights-slider-item");

    if (sliderEl?.swiper) sliderEl.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
    });

    section.classList.remove("has-active-slider");
  };

  const initHighlightsSwiper = (section) => {
    if (!section || !section?.classList.contains("highlights-section")) {
      return;
    }
    const sliderEl = section.querySelector(".js-highlights-slider");
    const contentEl = section.querySelector(".highlights__content");

    const syncFixedPanelHeight = () => {
      if (!sliderEl) return;
      const desktopLayout = sliderEl.dataset.desktopLayout || "grid";

      if (desktopLayout === "fixed" && contentEl && window.innerWidth >= 1160) {
        const height = contentEl.getBoundingClientRect().height;
        sliderEl.style.maxHeight = height ? `${height}px` : "";
      } else {
        sliderEl.style.maxHeight = "";
      }
    };

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const desktopLayout = sliderEl?.dataset.desktopLayout || "grid";
        const keepSliderAtDesktop = desktopLayout === "slider";

        if (window.innerWidth >= 1160 && !keepSliderAtDesktop) {
          destroySlider(section);
        } else {
          if (sliderEl?.swiper) {
            destroySlider(section);
          }
          initSlider(section);
        }
      });

      syncFixedPanelHeight();
    });

    resizeObserver.observe(section);
    if (contentEl) resizeObserver.observe(contentEl);
  };

  initHighlightsSwiper(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initHighlightsSwiper(event.target);
  });
})();
